// forms/nearMissForm/state.js

import { photosUIInitialState } from "../photosForm/photosFormState";

// Autosave error tracking state (field-level only, no row errors for Near Miss)
export const nearMissAutosaveErrorsInitialState = {
  hasErrors: false,
  lastError: null, // { key, message, timestamp, patchType }
  fieldErrors: {}, // { "near_miss_main.incident_date": "Invalid date format" }
};

export const nearMissFormUIInitialState = {
  loading: false,
  signatureModalOpen: false,
  currentSignatureRowId: null,
  currentSignatureImage: null,
  activeTab: "form", // "form" | "photos"
};

export const nearMissFormInitialState = {
  nearMissFormUI: nearMissFormUIInitialState,
  photosUI: { ...photosUIInitialState },
  autosaveErrors: nearMissAutosaveErrorsInitialState,
};
